import {createApp} from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import NutUI from "@nutui/nutui";
import "@nutui/nutui/dist/styles/themes/default.scss";
import './icons'
import SvgIcon from "@/components/SvgIcon";
import vue3PhotoPreview from 'vue3-photo-preview';
import 'vue3-photo-preview/dist/index.css';
import zwlogger from "@/utils/zwlogger";

router.beforeEach((to, from, next) => {
    const hasToken = !!store.state.accessToken;
    const isZlbLogin = localStorage.getItem('login_type') === 'zlb';
    const isZlbVerified = sessionStorage.getItem('zlb_face_verified') === '1';
    if (to.path === '/face-verify') {
        return next(isZlbLogin && hasToken ? undefined : {path: '/login', query: {redirect: to.fullPath}});
    }
    if (to.meta.auth && (!hasToken || (isZlbLogin && !isZlbVerified))) {
        return next({path: '/login', query: {redirect: to.fullPath}});
    }
    if (to.meta.auth) {
        zwlogger.sendPv(to.name, to?.meta?.title);
    }
    next();
});

const app = createApp(App);
app.component('svg-icon', SvgIcon);
app.use(NutUI).use(store).use(router).use(vue3PhotoPreview).mount('#app')
